/**
 * Route access policies built from the AuthContext platform_mode contract.
 * Keep route declarations readable while avoiding duplicated raw platform strings.
 *
 * Admin-only frontend access currently means `platform_mode === Admin_Mode`.
 * Backend AuthContext must normalize every frontend-admin user to Admin_Mode.
 * If tenant-admin or super-admin become separate claims later, update this
 * policy contract deliberately instead of adding ad hoc route checks.
 */
import { PLATFORM_MODES, PlatformMode } from '@app/core/models/platform-mode.model';

export const PLATFORM_ROUTE_ACCESS = {
    TENANT_ONLY: [PLATFORM_MODES.TENANT_BASE, PLATFORM_MODES.ADMIN_MODE],
    ADMIN_ONLY: [PLATFORM_MODES.ADMIN_MODE],
    INDIVIDUAL_ONLY: [PLATFORM_MODES.API_TENANT],
} as const satisfies Record<string, readonly PlatformMode[]>;

export type PlatformRouteAccess = readonly PlatformMode[];
